import { Pipe, PipeTransform } from '@angular/core';
import { GlobalConstants } from 'src/constants/global.constants';

@Pipe({
  name: 'resourceAuthor'
})
export class ResourceAuthorPipe implements PipeTransform {
  transform(value: string | undefined, item: { ruade?: boolean; ownerId?: string; owner?: string } | undefined): string {
    // En V2, une donnée générique créée par l'ACU porte son OwnerId ; le back la signale par le propriétaire « USIRF ».
    const isGeneric = !!item?.ruade && (!item.ownerId || item.ownerId === GlobalConstants.EMPTY_GUID || item.owner === GlobalConstants.GENERIC_RESOURCE_OWNER);
    return isGeneric ? GlobalConstants.GENERIC_RESOURCE_AUTHOR : value || '';
  }
}
